import "../../../css/ThankYou.css"
import React, { useContext } from "react";
import { Flex, Layout } from "antd";
import {
  HeaderComp,
  ButtonComp
} from '../../../components'
import { LangContext } from "../../../utils/LanguageProvider";
import Icon from "../../../media/images/icon-thnks.png";
import { title, content } from "../../../langs/ThankYou"
import { returnHome } from "../../../langs/buttons"

const { Header, Content } = Layout

const ThankYou = () => {
  const { lang } = useContext(LangContext);
  
  return (
    <>
      <Header>
        <div className="header-container">
          <HeaderComp />
        </div>
      </Header>
      <div className="full-container">
        <Flex vertical style={{ maxWidth: '1400px', width: '100%' }}>
          <Content className="global-content">
            <Flex className="ThankYou">
              <Flex className="ThankYou-box">
                <Flex className="ThankYou-title">
                    <img loading="lazy" src={Icon} alt="not-found"/>
                </Flex>
                <Flex style={{ textAlign: 'center' }}>
                  <p style={{ lineHeight: '52px' }}>
                    <span className='h4-headline-800'>{title[lang].first}</span>
                    <span className='h4-headline-500' style={{ color: '#0027F9'}}>{title[lang].last}</span>
                  </p>
                </Flex>
                <Flex>
                  <p 
                    className="s4-subtitle-500"
                    dangerouslySetInnerHTML={{ __html: content[lang] }}
                  />
                </Flex>
                <Flex className="ThankYou-actions">
                  <ButtonComp 
                    title={returnHome[lang]} 
                    url={`/${lang}/`}
                    classStyle="button-empty-md bt-medium-500"
                  />
                </Flex>
              </Flex>
            </Flex>
          </Content>
        </Flex>
      </div>
    </>
  );
}

export default ThankYou